import { render, staticRenderFns } from "./viewInventoryDetails.vue?vue&type=template&id=260124a7&scoped=true&"
import script from "./viewInventoryDetails.vue?vue&type=script&lang=ts&"
export * from "./viewInventoryDetails.vue?vue&type=script&lang=ts&"
import style0 from "./viewInventoryDetails.vue?vue&type=style&index=0&id=260124a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260124a7",
  null
  
)

export default component.exports